import { Chart } from "chart.js/auto";
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";
import { ref, createRef, Ref } from "lit/directives/ref.js";

@customElement("c-outliers")
export class OutliersWidget extends LitElement {
    static styles = css`
        :host {
            display: block;
            height: 100%;
        }
    `;

    canvas: Ref<HTMLCanvasElement> = createRef();

    async firstUpdated() {
        const data = {
            labels: [
                "E.on",
                "Emovy",
                "SV Sparkassenversicherung",
                "Majorel",
                "AG Wasserwerke",
            ],
            datasets: [
                {
                    axis: "y",
                    label: "Top 5 Outliers",
                    data: [542, 240, 100, 0, 0],
                    fill: false,
                    backgroundColor: "rgba(132, 44, 255, 0.7)",
                    borderWidth: 1,
                },
            ],
        };

        new Chart(this.canvas.value, {
            type: "bar",
            data,
            options: {
                indexAxis: "y",
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: "TOP 5 Outliers",
                    },
                },
            },
        });
    }

    render() {
        return html`<canvas ${ref(this.canvas)}></canvas>`;
    }
}
